import { TerminalError } from "@/utils/UTerminal";

import { TTerminalCommand } from "@/types";

import { typeArg } from "../args";

export const editCommand: TTerminalCommand = {
	command: "edit",
	description: "Edits an existing item",
	execute: () => {
		throw new TerminalError("Not implemented");
	},
	args: [typeArg({ description: "The type of item to edit" })],
};
